<button (click)="click($event)" class="item-content" [class.selected]="selected"> 
    <ng-content></ng-content>
</button>
